import client from './client';

export const getOtherDeductions = async (params = {}, options = {}) => {
  const res = await client.get('/other-deductions', { params, signal: options.signal });
  return res.data;
};

export const createOtherDeduction = async (payload) => {
  const res = await client.post('/other-deductions', payload);
  return res.data;
};

export const createOtherDeductionType = async (payload) => {
  const res = await client.post('/other-deductions/types', payload);
  return res.data;
};

export const getOtherDeductionTypes = async (params = {}) => {
  const res = await client.get('/other-deductions/types', { params });
  return res.data;
};

export const bulkUpdateOtherDeductionTypes = async (payload) => {
  const res = await client.patch('/other-deductions/types/bulk', payload);
  return res.data;
};

export const updateOtherDeductionType = async (typeId, payload) => {
  const res = await client.patch(`/other-deductions/types/${typeId}`, payload);
  return res.data;
};

export const updateOtherDeduction = async (deductionId, payload) => {
  const res = await client.put(`/other-deductions/${deductionId}`, payload);
  return res.data;
};

export const archiveOtherDeduction = async (deductionId) => {
  const res = await client.patch(`/other-deductions/${deductionId}/archive`);
  return res.data;
};

export const unarchiveOtherDeduction = async (deductionId) => {
  const res = await client.patch(`/other-deductions/${deductionId}/unarchive`);
  return res.data;
};

export const deleteOtherDeduction = async (deductionId) => {
  const res = await client.delete(`/other-deductions/${deductionId}`);
  return res.data;
};

export const deleteOtherDeductionType = async (typeId) => {
  const res = await client.delete(`/other-deductions/types/${typeId}`);
  return res.data;
};
